import React from "react";
import LogoSvg from "@/assets/CarlineConsensor-Primary-Square.svg";

const BackgroundLogo: React.FC = () => {
  return (
    <div
      className="
        fixed inset-0 z-10 
        flex items-center justify-center 
        pointer-events-none 
        animate-logo-fade-in
      "
    >
      <img
        src={LogoSvg}
        alt="Carline Consensor"
        className="h-[30vh] w-auto max-h-[600px] object-contain"
      />
    </div>
  );
};

export default BackgroundLogo;

